import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setBasicFilters } from '@/redux/store/actions/search';
import { CalendarPricingType } from '@/components/houses/_hooks/useProduct';
import Box from '@/components/UI/box/Box';
import Button from '@/components/UI/button/Button';
import WeekDatepicker from '@/components/datepicker/weekRangeDatepicker/WeekDatepicker';
import CalendarMobile from '@/components/reusable/searchDatePicker/calendarMobile/CalendarMobile';
import FooterDescription from '@/components/datepicker/instanstDescriptions/InstanstPeakDescription';
import useDrawer from '@/hooks/useDrawer';
import styles from './CalendarPricingMobile.module.scss';
const CalendarPricingMobile: React.FC<{
  hookData: CalendarPricingType;
  calendarRef: any;
  hasInstant;
}> = props => {
  const {
    hookData: {
      handleMultiCalendarChange,
      houseCalendarData
    }
  } = props;
  const {
    checkin,
    checkout,
    guests
  } = useSelector(state => state.basicFilters);
  const dispatch = useDispatch();
  const weekCalendarRef = React.useRef<any>(null);
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const handleDatePickerChange = (dates: any) => {
    dispatch(setBasicFilters({
      checkin: dates.checkin,
      checkout: dates.checkout,
      guests
    }));
    if (dates.submited) {
      drawerClose();
      weekCalendarRef?.current?.setCalendarDates(dates.checkin, dates.checkout);
    }
  };
  useEffect(() => {
    if (checkout && isDrawerOpen('CALENDAR_PRICING')) {
      weekCalendarRef?.current?.setCalendarDates(checkin, checkout);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkin, checkout]);
  const resetFilterCalender = () => {
    weekCalendarRef.current?.cleanValue();
    dispatch(setBasicFilters({
      checkin: null,
      checkout: null,
      guests
    }));
  };
  return <Box className={styles['calendar-pricing']} data-sentry-element="Box" data-sentry-component="CalendarPricingMobile" data-sentry-source-file="CalendarPricingMobile.tsx">
      {houseCalendarData?.calendar && !isDrawerOpen('CALENDAR_PRICING') && <WeekDatepicker dateRef={weekCalendarRef} dates={{
      checkin,
      checkout
    }} onChange={handleDatePickerChange} hasCalendar calendar={houseCalendarData.calendar} isFull endDay={houseCalendarData.endDay} getCalendarFunc={handleMultiCalendarChange} nextRangeMonths={houseCalendarData.differenceInDays} footerChildren={<Box className={styles['calendar-pricing-footer']}>
              <Box className={styles['calendar-pricing-footer-desc']}>
                <FooterDescription />
              </Box>
              <Box className="footer-show-more">
                <Button onClick={() => drawerOpen('CALENDAR_PRICING')} format={'text'} size="small" endIcon="arrow-left-1">
                  {`مشاهده روزهای بیشتر `}
                </Button>
              </Box>
            </Box>} />}
      <CalendarMobile open={isDrawerOpen('CALENDAR_PRICING')} onClose={() => drawerClose()} resetFilter={resetFilterCalender} handleDatePickerChange={handleDatePickerChange} calendarRef={props.calendarRef} isFull backIcon hasInstant={props.hasInstant} data-sentry-element="CalendarMobile" data-sentry-source-file="CalendarPricingMobile.tsx" />
    </Box>;
};
export default CalendarPricingMobile;